<template>
  <div class="animated fadeIn">
    <b-row class="my-4">
      <b-col
        sm="7"
        class="text-left"
      >
        <h5>가족 사항(Family)</h5>
      </b-col>
      <b-col
        sm="5"
        class="text-right"
      >
        <b-button
          v-if="!freezing"
          :size="'sm'"
          :variant="'info'"
          @click="addFamily()"
        >
          가족 추가(More)
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-input-group>
          <b-form-input
            class="title"
            placeholder="관계"
            :disabled="true"
          />
          <b-form-input
            class="title"
            placeholder="이름"
            :disabled="true"
          />
          <b-form-input
            class="title"
            placeholder="교회 또는 종교"
            :disabled="true"
          />
          <b-form-input
            class="title"
            placeholder="직분"
            :disabled="true"
          />
          <b-form-input
            class="title"
            placeholder="핸드폰"
            :disabled="true"
          />
          <b-input-group-append>
            <b-button
              v-show="(!freezing && families.length > 1)"
              :disabled="true"
            >
              X
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row
      v-for="(family, idx) in families"
      :key="idx"
      no-gutters
    >
      <b-col md="12">
        <b-input-group>
          <b-form-input
            v-model="family[0]"
            v-validate.initial="veeRequired"
            class="form-control"
            :readonly="freezing"
            type="text"
            placeholder="Releation"
            :name="'familyRel' + String(idx)"
            :state="isValid('familyRel' + String(idx))"
          />
          <b-form-input
            v-model="family[1]"
            v-validate.initial="veeRequired"
            class="form-control"
            :readonly="freezing"
            type="text"
            placeholder="Name"
            :name="'familyName' + String(idx)"
            :state="isValid('familyName' + String(idx))"
          />
          <b-form-input
            v-model="family[2]"
            v-validate.initial="veeRequired"
            class="form-control"
            :readonly="freezing"
            type="text"
            placeholder="Church or Religion"
            :name="'familyChurch' + String(idx)"
            :state="isValid('familyChurch' + String(idx))"
          />
          <b-form-input
            v-model="family[3]"
            v-validate.initial="veeRequired"
            class="form-control"
            :readonly="freezing"
            type="text"
            placeholder="Position"
            :name="'familyTitle' + String(idx)"
            :state="isValid('familyTitle' + String(idx))"
          />
          <b-form-input
            v-model="family[4]"
            v-validate.initial="veeMobile"
            :name="'familyMobile' + String(idx)"
            :state="isValid('familyMobile' + String(idx))"
            :readonly="freezing"
            placeholder="Mobile"
          />
          <b-input-group-append>
            <b-button
              v-show="(!freezing && families.length > 1)"
              variant="danger"
              @click="deleteFamily(idx)"
            >
              X
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <!-- 가족사항 끝-->
    <b-row v-if="checkSiblingTerm !== ''">
      <b-col md="12">
        <hr>
        <b-row>
          <b-col
            md="12"
            class="text-left"
          >
            <h5>이번에 함께 신청한 가족</h5>
          </b-col>
        </b-row>
        <b-row
          v-for="(s, idx) in siblings"
          :key="idx"
        >
          <b-col md="12">
            {{ s }}
          </b-col>
        </b-row>
        <hr>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'

export default {
  name: 'RemnantFamily',
  props: {
    email: {
      type: String,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: true
    },
    checkSiblingTerm: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function () {
    return {
      veeMobile: {
        required: true,
        regex: /^(([0][1][1769][0-9][0-9][0-9][0-9][0-9][0-9][0-9])|([0][1][0][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]))$/
      },
      veeRequired: {
        required: true
      },
      families: [],
      siblings: []
    }
  },
  computed: {
    freezing () {
      return this.readOnly
    }
  },
  mounted () {
    if (this.email !== '') {
      this.getDetailInfo(1)
    } else {
      this.addFamily()
    }
  },
  methods: {
    isValid (name) {
      if (this.$validator.flags[name] === undefined) {
        return null
      } else if (!this.$validator.flags[name].validated) {
        return null
      } else {
        return this.$validator.flags[name].valid
      }
    },
    addFamily () {
      this.families.push(['', '', '', '', ''])
      this.$validator.reset()
    },
    deleteFamily (idx) {
      if (idx > -1 && this.families.length > 1) {
        this.families.splice(idx, 1)
      }
      this.$validator.reset()
    },
    alertNotFound () {
      alert('등록된 정보가 없습니다!')
    },
    exportData (postArg) {
      /* family 가족 끼리는 :, 한명의 정보는 _ */
      if (this.families.length === 0) {
        postArg['ERROR'] = 'family'
      }
      var familyStr = ''
      for (var i = 0; i < this.families.length; i++) {
        if (this.errors.has('familyMobile' + String(i))) {
          postArg['ERROR'] = 'family'
          return postArg
        }
        var tempFamilyStr = ''
        if (this.families[i][0] !== '' && this.families[i][1] !== '' && this.families[i][2] !== '' && this.families[i][3] !== '' && this.families[i][4] !== '') {
          tempFamilyStr += this.families[i][0] + '_' // 관계
          tempFamilyStr += this.families[i][1] + '_' // 이름
          tempFamilyStr += this.families[i][2] + '_' // 교회
          tempFamilyStr += this.families[i][3] + '_' // 직분
          tempFamilyStr += this.families[i][4] // 핸드폰
        } else {
          postArg['ERROR'] = 'retry'
          return postArg
        }
        if (tempFamilyStr !== '') {
          if (familyStr !== '') {
            familyStr += ':'
          }
          familyStr += tempFamilyStr
        }
      }
      postArg['family'] = familyStr
      return postArg
    },
    parseDetailInfo (data) {
      for (var i = 0; i < data.family.length; i++) {
        this.addFamily()
        this.families[this.families.length - 1][0] = data.family[i].relation
        this.families[this.families.length - 1][1] = data.family[i].name
        this.families[this.families.length - 1][2] = data.family[i].church
        this.families[this.families.length - 1][3] = data.family[i].title
        this.families[this.families.length - 1][4] = data.family[i].mobile
      }
      if (this.checkSiblingTerm !== '') {
        if (data.siblings === undefined) {
          this.siblings = ['없음']
          return
        }
        Object.keys(data.siblings).forEach(k => {
          this.siblings.push(data.siblings[k].name + '(' + data.siblings[k].part + ')')
        })
        if (this.siblings.length === 0) {
          this.siblings = ['없음']
        }
      }
      this.$validator.reset()
    },
    getDetailInfo (info) {
      if (this.errors.has('email')) {
        this.alertRetryEmail()
        return
      }
      api.request('get', '/remnant/check?' + 'email=' + this.email + '&ic=family&info=' + info + '&term=' + this.checkSiblingTerm)
        .then(response => {
          var data = response.data
          if (data.error) {
            this.alertFail(data.error)
            return
          }
          if (data.check === 1 && info === 1) {
            // 로그인 후 정보수정으로 들어옴
            this.parseDetailInfo(data)
            // email잠구자
          } else {
            // insert
            // this.alertNotFound()
          }
        })
        .catch(error => {
          console.log(error)
        })
      this.$validator.reset()
    }
  }
}
</script>

<style scoped>
.title {
  background-color:white;
  font-weight: bold;
  color: black;
}
</style>
